import React from 'react'
import styled from 'styled-components'
import { useSettings } from '../../providers'
import { OptionButton } from '../OptionButton'

interface Props {
  symbol?: string
  className?: string
}

export function UseWethButton({ symbol, className }: Props) {
  const { settings, setSettings } = useSettings()

  const useWethButton = getButtonState(settings.useWeth, symbol)

  function toggleUseWeth() {
    setSettings({ ...settings, useWeth: !settings.useWeth })
  }

  return (
    <>
      {useWethButton.show && (
        <Button className={className} title="Switch between ETH and WETH" onClick={toggleUseWeth}>
          {useWethButton.text}
        </Button>
      )}
    </>
  )
}

function getButtonState(useWeth: boolean, symbol?: string) {
  if (symbol && ['ETH', 'KETH', 'GETH', 'WETH'].includes(symbol)) {
    return useWeth ? { text: 'Use ETH', show: true } : { text: 'Use WETH', show: true }
  }
  return { show: false }
}

const Button = styled(OptionButton)`
  margin: 0 0 0 auto;
  align-self: flex-end;
`
